module.exports = __webpack_public_path__ + "static/media/how-to-get-a-job-in-data-science.8d559cc5.md";